import PropTypes from "prop-types";
import {IconButton} from "@mui/material";
import {Delete as DeleteIcon, Edit as EditIcon} from "@mui/icons-material";
import DataTable from "../../../components/DataTable";

/**
 * Thin wrapper around the generic DataTable for the
 * camera → room mapping list inside Branch Details.
 *
 * Each row is shaped { cctv, camera, room, ... }, so each column
 * pulls from its specific nested object via renderCell.
 */
function CameraRoomMappingTable({rows, handleDeleteClick, handleEditClick}) {
    const columns = [
        {
            name: "cctv",
            value: "cctvLocation",
            align: "left",
            width: "10",
            renderCell: (row) => row?.cctv?.locationDescription,
        },
        {
            name: "camera",
            value: "cameraChannel",
            align: "left",
            width: "10",
            renderCell: (row) => row?.camera?.channel,
        },
        {
            name: "Room",
            value: "roomName",
            align: "left",
            width: "10",
            renderCell: (row) => row?.room?.name,
        },
        {
            name: "status",
            value: "cameraStatus",
            align: "left",
            width: "10",
            renderCell: (row) => row?.camera?.status,
        },
        {
            name: "Actions",
            value: "action",
            align: "center",
            width: "10",
            renderCell: (row) => (
                <>
                    <IconButton color="error" size="small" onClick={() => handleDeleteClick(row)}>
                        <DeleteIcon/>
                    </IconButton>
                    <IconButton color="primary" size="small" onClick={() => handleEditClick(row)}>
                        <EditIcon/>
                    </IconButton>
                </>
            ),
        },
    ];

    return <DataTable columns={columns} rows={rows}/>;
}

CameraRoomMappingTable.propTypes = {
    rows: PropTypes.array,
    handleDeleteClick: PropTypes.func.isRequired,
    handleEditClick: PropTypes.func.isRequired,
};

CameraRoomMappingTable.defaultProps = {
    rows: [],
};

export default CameraRoomMappingTable;
